import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { Fieldset } from 'primeng/fieldset';
import { AppError } from '../../shared/services/state.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [Fieldset],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit {
  title = 'Error Occurred';
  error = input<AppError>();

  ngOnInit(): void {
    console.info('error in Error Component:', this.error())
  }
}
